<template>
  <el-dialog
    class="import-excel-popup"
    :title="`Import dữ liệu`"
    :width="isContinue ? '500px' : '1024px'"
    :visible="visible"
    :show-close="!importing"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <div v-if="!isContinue">
      <el-row
        class="mt-0 mb-m"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <h3 class="text-center mt-0">
          {{ excelTitle }} ({{ filteredImportData.length }})
        </h3>
        <div
          style="display: flex;
          align-items: center;"
          class="w-50"
        >
          <el-select
            v-model="selectedTemplate"
            class="mr-m"
          >
            <el-option
              v-for="c in [
                {
                  value: '',
                  label: 'Mặc định'
                },
                {
                  value: 0,
                  label: 'File mẫu 1'
                }
              ]"
              :key="c.value"
              :label="c.label"
              :value="c.value"
            />
          </el-select>
          <el-input
            v-model="searchText"
            placeholder="Nhập thông tin để tìm kiếm"
            @input="() => (selectedRows = [])"
          />
        </div>
      </el-row>
      <el-table
        :data="filteredImportData.map((d, index) => ({ ...d, stt: index + 1 }))"
        style="width: 100%"
        height="450"
        stripe
      >
        <el-table-column
          key="checkbox"
          label=""
          width="50"
          fixed="left"
        >
          <template slot-scope="scope">
            <el-checkbox
              :value="selectedRows.includes(scope.row.stt)"
              @change="(v) => handleSelectRow(scope.row.stt, v)"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in [
            {
              key: 'stt',
              label: 'STT',
              fixed: 'left',
              width: 60,
            },
            ...excelColumns,
          ]"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :min-width="column.width"
          :fixed="column.fixed"
        >
          <template slot-scope="scope">
            <div
              class="text-limited text-limited__2"
              :title="scope.row[column.key]"
            >
              {{
                column.locale
                  ? scope.row[column.locale][column.column_key]
                  : scope.row[column.key]
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <el-radio
        v-model="isCreate"
        :label="1"
      > Thêm mới </el-radio>
      <el-radio
        v-model="isCreate"
        :label="0"
      > Cập nhật </el-radio>
      <div
        v-if="isCreate"
        class="mt-l"
        style="word-break: break-word"
      >
        <p>
          Dữ liệu hợp lệ: {{ validData.length }}/{{ checkedImportData.length }}
        </p>
        <p>
          * Ghi chú: dữ liệu hợp lệ khi bảng dữ liệu có các trường bắt buộc.
        </p>
        <p>Toàn bộ dữ liệu hợp lệ sẽ được khởi tạo và thêm mới vào hệ thống.</p>
        Kết quả sau khi thêm mới: {{ createdTotal }} phần tử
      </div>
      <div
        v-else
        class="mt-l"
        style="word-break: break-word"
      >
        <p>
          Dữ liệu hợp lệ: {{ validData.length }}/{{ checkedImportData.length }}
        </p>
        <p>
          * Ghi chú: dữ liệu hợp lệ khi bảng dữ liệu có các trường bắt buộc là
          "ID"....
        </p>
        <p>
          Toàn bộ dữ liệu hợp lệ sẽ được đọc và cập nhật theo "ID" vào hệ thống.
          Sau khi cập nhật số lượng phần tử không thay đổi nhưng dữ liệu sẽ được
          làm mới.
        </p>
        <p>Lưu ý: Nếu không tìm thấy "ID" đã lưu thì hệ thống sẽ bỏ qua.</p>
      </div>
      <div
        v-if="importing"
        class="mt-l"
      >
        <el-progress
          :percentage="percentage"
          :stroke-width="12"
        />
      </div>
    </div>
    <span slot="footer">
      <el-row
        type="flex"
        align="middle"
        justify="end"
      >
        <el-button
          v-if="!isContinue"
          type="primary"
          @click="
            () => {
              isContinue = true;
            }
          "
        >
          Tiếp tục
        </el-button>
        <el-button
          v-if="isContinue"
          type="info"
          class="mr-2"
          :disabled="importing"
          @click="
            () => {
              isContinue = false;
            }
          "
        >
          Quay lại
        </el-button>
        <el-button
          v-if="isContinue"
          type="primary"
          :loading="importing"
          :disabled="validData.length <= 0"
          @click="() => handleImportData()"
        >
          Xác nhận
        </el-button>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { convertData } from "@/utils/import";
import { convertPayloadData, arrayToObject } from "@/utils/common";
import commonServices from "@/services/common";
import fileServices from "@/services/file";
import constants from '@/config/constants';
import organizationServices from "@/services/organization";

export default {
  name: "ImportExcelPopup",
  components: {},
  props: {
    title: String,
    visible: Boolean,
    columns: Array,
    type: String,
    objectType: String,
    total: Number,
    excelData: Array,
    templates: Array
  },
  data() {
    return {
      importing: false,
      isContinue: false,
      isCreate: 1,
      imported: 0,
      importSize: 10,
      selectedRows: [],
      searchText: "",
      selectedTemplate: "",
      fileType: constants.FIELD_TYPE,
      allFiles: [],
      organizationId: organizationServices.getCurrentOrg()?.id,
    };
  },
  computed: {
    ...mapGetters("category", ["allCategories"]),
    ...mapGetters("config", ["allConfigs"]),
    excelTitle() {
      return this.title;
    },
    excelColumns() {
      return [
        {
          key: "id",
          label: "Mã",
          fixed: "left",
          width: 100,
        },
        ...this.columns.map((c) => ({
          ...c,
          label: c.label || c.name,
          field: c.key,
          width: c.width || 150,
        })),
      ];
    },
    currentTemplate() {
      if (this.selectedTemplate === '') {
        return null
      }
      return this.templates[this.selectedTemplate] || null
    },
    templateData() {
      if (this.currentTemplate) {
        return this.excelData.map((d) => {
          const result = {};
          const tFields = this.currentTemplate.fields;
          Object.keys(tFields).forEach(key => {
            result[key] = d[tFields[key]]
          });
          return result;
        })
      }
      return this.excelData
    },
    newCategories() {
      const categoryFields = this.excelColumns.filter((c) => [this.fileType.SELECT, this.fileType.MULTIPLE_SELECT].includes(c.type) && !!c.options.type);
      const categories = [];
      this.templateData.forEach((d) => {
        categoryFields.forEach(field => {
          const value = d[field.key]?.trim();
          if (value) {
            const isOld = this.allCategories.find((c) => c.type === field.options.type && c.extra.name === value);
            if (!isOld) {
              const isExist = categories.find((c) => c.type === field.options.type && c.name === value);
              if (!isExist) {
                categories.push({
                  type: field.options.type,
                  name: value
                })
              }
            }
          }
        });
      })
      return categories;
    },
    filteredImportData() {
      return this.templateData.filter((d) => {
        if (this.searchText) {
          let result = false;
          const keys = Object.keys(d);
          for (let i = 0; i < keys.length; i++) {
            if (d[keys[i]]) {
              if (typeof d[keys[i]] !== "object") {
                const value = d[keys[i]].toString();
                if (
                  value.toLowerCase().includes(this.searchText.toLowerCase())
                ) {
                  result = true;
                }
              } else {
                const oKeys = Object.keys(d[keys[i]]);
                for (let j = 0; j < oKeys.length; j++) {
                  if (d[keys[i]][oKeys[j]]) {
                    if (typeof d[keys[i]][oKeys[j]] !== "object") {
                      const value = d[keys[i]][oKeys[j]].toString();
                      if (
                        value
                          .toLowerCase()
                          .includes(this.searchText.toLowerCase())
                      ) {
                        result = true;
                      }
                    }
                  }
                }
              }
            }
            if (result) {
              break;
            }
          }
          return result;
        }
        return true;
      });
    },
    checkedImportData() {
      if (this.selectedRows.length > 0) {
        return this.filteredImportData.filter((d, index) =>
          this.selectedRows.includes(index + 1)
        );
      } else {
        return this.filteredImportData;
      }
    },
    validData() {
      return this.checkedImportData.filter((d) =>
        this.isCreate ? true : !!d.id
      );
    },
    createdTotal() {
      return this.total + (this.validData.length || 0);
    },
    percentage() {
      if (this.validData.length > 0) {
        return Number(
          Number.parseFloat(
            (this.imported / this.validData.length) * 100
          ).toFixed(0)
        );
      }
      return 0;
    },
    payloadData() {
      return this.validData.map((d) => {
        const data = convertData(d, this.excelColumns, this.allCategories, this.allFiles);
        return data;
      });
    },
    requestType() {
      if (this.objectType === "categories") {
        return "extras";
      }
      return this.objectType;
    },
    payloadType() {
      if (this.objectType === "categories") {
        return "category";
      }
      return this.type;
    },
    fileParams() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
      };
      _params.filters = {
        organization_id: this.organizationId,
      };
      return _params;
    }
  },
  beforeMount() {
    this.getFiles();
  },
  methods: {
    ...mapActions("category", ["setAllCategories"]),
    handleSelectRow(stt, isChecked) {
      if (isChecked) {
        this.selectedRows = [...this.selectedRows, stt];
      } else {
        this.selectedRows = this.selectedRows.filter((r) => r !== stt);
      }
    },

    async getFiles() {
      fileServices.list(this.fileParams).then((response) => {
        this.allFiles = response.items
      }).catch(() => {
        this.allFiles = []
      });
    },

    async handleSaveNewCategories() {
      if (this.newCategories.length > 0) {
        const requests = this.newCategories.map((p) => this.handleCreateCategory(p));
        await Promise.all(requests);
        await this.setAllCategories();
      }
    },

    async handleImportData() {
      this.importing = true;
      await this.handleSaveNewCategories();
      setTimeout(async () => {
        if (this.isCreate === 1) {
          await this.createData();
        } else {
          await this.updateData();
        }
        setTimeout(() => {
          this.importing = false;
          this.$emit("reload");
          this.$emit("close");
          this.$notify.success({
            title: "Thông báo !",
            message: "Import dữ liệu thành công !",
          });
        }, 1000);
      }, 1000)
    },

    async createData() {
      let i = 0;
      while (i < this.payloadData.length) {
        const payloads = this.payloadData.slice(i, i + this.importSize);
        const requests = payloads.map((p) => this.handleCreateData(p));
        await Promise.all(requests);
        i = i + this.importSize;
        this.imported =
          i > this.payloadData.length ? this.payloadData.length : i;
      }
    },

    async updateData() {
      let i = 0;
      while (i < this.payloadData.length) {
        const payloads = this.payloadData.slice(i, i + this.importSize);
        const requests = payloads.map((p) => this.handleUpdateData(p));
        await Promise.all(requests);
        i = i + this.importSize;
        this.imported =
          i > this.payloadData.length ? this.payloadData.length : i;
      }
    },

    async handleCreateCategory(category) {
      const categoryConfig = this.allConfigs.find((c) => c.extra.key === category.type);
      const categoryFields = categoryConfig.extra.fields;
      const defaultData = arrayToObject(categoryFields)
      const p = {
        ...convertPayloadData(category.type, {
          type: category.type,
          extra: {
            ...defaultData,
            name: category.name,
          },
        }),
      };
      await commonServices.create('categories', p);
    },

    async handleCreateData(payload) {
      delete payload?.id;
      const p = {
        ...convertPayloadData(this.payloadType, {
          extra: {
            ...payload,
          },
        }),
      };
      await commonServices.create(this.requestType, p);
    },

    async handleUpdateData(payload) {
      try {
        const originData = await commonServices.show(
          this.requestType,
          payload.id
        );
        if (originData) {
          delete payload?.id;
          const p = {
            ...convertPayloadData(this.payloadType, {
              ...originData,
              extra: {
                ...originData.extra,
                ...payload,
              },
            }, originData),
          };
          await commonServices.update(this.requestType, p);
        }
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.import-excel-popup {
  .el-dialog__body {
    padding-top: 10px;
    .el-table {
      .el-table__header-wrapper {
        table {
          thead {
            tr {
              th {
                .cell {
                  word-break: break-word !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
